// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1920":"76a0a2f6","2889":"46738fb2","7963":"4ea25bf5","8607":"fb6274d5"}[chunkId] + ".chunk.css";
};